// extracted by mini-css-extract-plugin
export var card_shadow = "index-module--card_shadow--9Ig9Q";
export var module_btn = "index-module--module_btn--vvYAa";
export var processing = "index-module--processing--YkvDu";